import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: "jp",
        lng: 'jp',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: require("./locales/en/translations.json"),
            },
            jp: {
                translation: require("./locales/jp/translations.json"),
            },
        },
    });

export default i18n;